<template>
  <RegionIssueOverlay>
    <IssueLocation
      :inspectionId="inspectionId"
      :issueNavBackRoute="issueNavBackRoute"
      :organisationId="organisationId"
      :shipId="shipId"
    />
  </RegionIssueOverlay>
</template>
<script setup>
import { computed } from 'vue';
// TODO: will add when ships HME ready
// import { useRoute } from 'vue-router';

import IssueLocation from '@/components/ships/location/issue_location_ship.vue';
import RegionIssueOverlay from '@/components/regions/regions_issue_overlay.vue';

defineProps({
  organisationId: { type: String, required: true },
  inspectionId: { type: String, required: true },
  shipId: { type: String, required: true },
  issueId: { type: String, required: false, default: null },
});

// TODO: will add when ships HME ready
// const route = useRoute();

// Set back route based on props
const issueNavBackRoute = computed(() => {
  return 'shipRegionsIssue';
  // TODO: will add when ships HME ready
  // switch (true) {
  //   case isType('ship'):
  //     return 'shipRegionsIssue';
  //   default:
  //     // TODO: update to the regions issue overlay page when ready
  //     return 'shipRegionsTypeHmes';
  // }
});

// TODO: will add when ships HME ready
// function isType(type) {
//   return route.fullPath.includes(type);
// }
</script>
